document.documentElement.classList.add('js');
document.querySelectorAll('[data-language-select]').forEach(select => {
  select.addEventListener('change', () => select.form.requestSubmit());
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
});
document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => { link.closest('details').open = false; }));
document.querySelectorAll('.hero-visual').forEach(hero => {
  const video = hero.querySelector('.hero-motion');
  const toggle = hero.querySelector('.hero-video-toggle');
  if (!video || !toggle) return;
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = motionPreference.matches;
  const updateToggle = () => {
    toggle.querySelector('[data-video-toggle-label]').textContent = video.paused ? toggle.dataset.play : toggle.dataset.pause;
    toggle.querySelector('[data-video-toggle-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
  };
  video.muted = true;
  toggle.hidden = false;
  video.addEventListener('play', updateToggle);
  video.addEventListener('pause', updateToggle);
  toggle.addEventListener('click', () => {
    userPaused = !video.paused;
    if (userPaused) video.pause();
    else video.play().catch(updateToggle);
  });
  motionPreference.addEventListener('change', event => {
    userPaused = event.matches;
    if (userPaused) video.pause();
  });
  new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !userPaused) video.play().catch(updateToggle);
    else video.pause();
  }, { threshold: 0.1 }).observe(video);
  updateToggle();
});
